// extracted by mini-css-extract-plugin
module.exports = {"title":"infoTour_title__2tvJZ","icon":"infoTour_icon__2YIqi","containerItems":"infoTour_containerItems__2aOUY","item":"infoTour_item__27Y7y"};